import React from 'react';
import './InputComp.css';

const InputComp = (props) => {
  return (
    <div class="mb-3 row align-items-center edit-input">
      <div class="col-sm-2">
        <label for="inputPassword6" class="col-form-label">{props.title}</label>
      </div>
      <div class="col-sm-4">
        <input type={props.type} class="form-control form-control-lg" placeholder={props.placeholder} />
      </div>
    </div>
  )
}

export default InputComp;